/**
 * 车牌号高亮 mixin
 *
 * 提供 splitByPlate(content) 方法，把字符串拆成 [{text, isPlate}] 片段数组，
 * 供 template 用 <template v-for> 配合 v-if 渲染：
 *   - isPlate === true：套 .plate-span 类（黑底粗体大字）
 *   - isPlate === false：普通文本
 *
 * 每次调用都新建 RegExp 实例，避免 module-level regex 的 lastIndex
 * 跨组件实例 / 跨调用累积。
 *
 * 拆出来的实例正则匹配规则覆盖所有合法车牌：
 *   - 首字符：34 个省级行政区汉字简称
 *   - 第二字符：字母 A-Z
 *   - 后续 3-6 位：字母或数字
 *   - 尾部可选：挂 / 学 / 警 / 港 / 澳
 */
export default {
  methods: {
    splitByPlate(content) {
      if (!content) return [];
      const result = [];
      let lastIndex = 0;
      // 每次新建 regex 实例（new RegExp），绝对避免 module-level regex 的 lastIndex 跨调用累积
      const re = /[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼][A-Z][A-Z0-9]{3,6}[挂学警港澳]?/g;
      let m;
      while ((m = re.exec(content)) !== null) {
        // 【括号扩展】车牌号前后紧邻 `（` / `(` / `）` / `)` 时，把括号一起归入 plate part，
        //   让包裹车牌的整段括号都被渲染成红色加粗（用户消息气泡里 `继续使用该车头（皖KZ1968）`）。
        //   没有车牌号匹配的孤立括号不会被扩展（因为正则只匹配车牌号本身）。
        let leftStart = m.index;
        if (leftStart > 0 && (content[leftStart - 1] === '（' || content[leftStart - 1] === '(')) {
          leftStart -= 1;
        }
        let rightEnd = m.index + m[0].length;
        if (rightEnd < content.length && (content[rightEnd] === '）' || content[rightEnd] === ')')) {
          rightEnd += 1;
        }
        if (leftStart > lastIndex) {
          result.push({ text: content.slice(lastIndex, leftStart), isPlate: false });
        }
        result.push({ text: content.slice(leftStart, rightEnd), isPlate: true });
        lastIndex = rightEnd;
        if (m.index === re.lastIndex) re.lastIndex++;
      }
      if (lastIndex < content.length) {
        result.push({ text: content.slice(lastIndex), isPlate: false });
      }
      return result;
    },
  },
};
